import { Box, Chip, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";

const CoverageControlsLabel = ({ compliant, total }) => {
  const colors = useColors();

  return (
    <Chip
      label={
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="overline" sx={{ color: colors.text_secondary }}>
            {compliant}
          </Typography>
          <Typography variant="caption" sx={{ color: colors.text_secondary }}>
            {`/${total}`}
          </Typography>
        </Box>
      }
      sx={{
        borderRadius: "12px",
        background: "transparent",
        border: "0.5px solid " + colors.grey_light,
        alignItems: "center",
        display: "flex",
        padding: "5px 0px",
        height: "24px",
      }}
    />
  );
};

export default CoverageControlsLabel;
